module.exports = __webpack_public_path__ + "static/img/15.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/15.png
// module id = 0Fu1
// module chunks = 0